export const theme = {
  colors: {
    gray5: 'var(--gray5)',
    gray10: 'var(--gray10)',
    gray15: 'var(--gray15)',
    gray20: 'var(--gray20)',
    gray25: 'var(--gray25)',
    gray30: 'var(--gray30)',
    gray35: 'var(--gray35)',
    gray40: 'var(--gray40)',
    gray45: 'var(--gray45)',
    gray50: 'var(--gray50)',
    gray55: 'var(--gray55)',
    gray60: 'var(--gray60)',
    gray65: 'var(--gray65)',
    gray70: 'var(--gray70)',
    gray75: 'var(--gray75)',
    gray80: 'var(--gray80)',
    gray85: 'var(--gray85)',
    gray90: 'var(--gray90)',
    gray95: 'var(--gray95)',
    gray100: 'var(--gray100)',
    red5: 'var(--red5)',
    red10: 'var(--red10)',
    red15: 'var(--red15)',
    red20: 'var(--red20)',
    red25: 'var(--red25)',
    red30: 'var(--red30)',
    red35: 'var(--red35)',
    red40: 'var(--red40)',
    red45: 'var(--red45)',
    red50: 'var(--red50)',
    red55: 'var(--red55)',
    red60: 'var(--red60)',
    red65: 'var(--red65)',
    red70: 'var(--red70)',
    red75: 'var(--red75)',
    red80: 'var(--red80)',
    red85: 'var(--red85)',
    red90: 'var(--red90)',
    red95: 'var(--red95)',
    red100: 'var(--red100)',
    magenta5: 'var(--magenta5)',
    magenta10: 'var(--magenta10)',
    magenta15: 'var(--magenta15)',
    magenta20: 'var(--magenta20)',
    magenta25: 'var(--magenta25)',
    magenta30: 'var(--magenta30)',
    magenta35: 'var(--magenta35)',
    magenta40: 'var(--magenta40)',
    magenta45: 'var(--magenta45)',
    magenta50: 'var(--magenta50)',
    magenta55: 'var(--magenta55)',
    magenta60: 'var(--magenta60)',
    magenta65: 'var(--magenta65)',
    magenta70: 'var(--magenta70)',
    magenta75: 'var(--magenta75)',
    magenta80: 'var(--magenta80)',
    magenta85: 'var(--magenta85)',
    magenta90: 'var(--magenta90)',
    magenta95: 'var(--magenta95)',
    magenta100: 'var(--magenta100)',
    purple5: 'var(--purple5)',
    purple10: 'var(--purple10)',
    purple15: 'var(--purple15)',
    purple20: 'var(--purple20)',
    purple25: 'var(--purple25)',
    purple30: 'var(--purple30)',
    purple35: 'var(--purple35)',
    purple40: 'var(--purple40)',
    purple45: 'var(--purple45)',
    purple50: 'var(--purple50)',
    purple55: 'var(--purple55)',
    purple60: 'var(--purple60)',
    purple65: 'var(--purple65)',
    purple70: 'var(--purple70)',
    purple75: 'var(--purple75)',
    purple80: 'var(--purple80)',
    purple85: 'var(--purple85)',
    purple90: 'var(--purple90)',
    purple95: 'var(--purple95)',
    purple100: 'var(--purple100)',
    blue5: 'var(--blue5)',
    blue10: 'var(--blue10)',
    blue15: 'var(--blue15)',
    blue20: 'var(--blue20)',
    blue25: 'var(--blue25)',
    blue30: 'var(--blue30)',
    blue35: 'var(--blue35)',
    blue40: 'var(--blue40)',
    blue45: 'var(--blue45)',
    blue50: 'var(--blue50)',
    blue55: 'var(--blue55)',
    blue60: 'var(--blue60)',
    blue65: 'var(--blue65)',
    blue70: 'var(--blue70)',
    blue75: 'var(--blue75)',
    blue80: 'var(--blue80)',
    blue85: 'var(--blue85)',
    blue90: 'var(--blue90)',
    blue95: 'var(--blue95)',
    blue100: 'var(--blue100)',
    green5: 'var(--green5)',
    green10: 'var(--green10)',
    green15: 'var(--green15)',
    green20: 'var(--green20)',
    green25: 'var(--green25)',
    green30: 'var(--green30)',
    green35: 'var(--green35)',
    green40: 'var(--green40)',
    green45: 'var(--green45)',
    green50: 'var(--green50)',
    green55: 'var(--green55)',
    green60: 'var(--green60)',
    green65: 'var(--green65)',
    green70: 'var(--green70)',
    green75: 'var(--green75)',
    green80: 'var(--green80)',
    green85: 'var(--green85)',
    green90: 'var(--green90)',
    green95: 'var(--green95)',
    green100: 'var(--green100)',
    coldGray5: 'var(--coldGray5)',
    coldGray10: 'var(--coldGray10)',
    coldGray15: 'var(--coldGray15)',
    coldGray20: 'var(--coldGray20)',
    coldGray25: 'var(--coldGray25)',
    coldGray30: 'var(--coldGray30)',
    coldGray35: 'var(--coldGray35)',
    coldGray40: 'var(--coldGray40)',
    coldGray45: 'var(--coldGray45)',
    coldGray50: 'var(--coldGray50)',
    coldGray55: 'var(--coldGray55)',
    coldGray60: 'var(--coldGray60)',
    coldGray65: 'var(--coldGray65)',
    coldGray70: 'var(--coldGray70)',
    coldGray75: 'var(--coldGray75)',
    coldGray80: 'var(--coldGray80)',
    coldGray85: 'var(--coldGray85)',
    coldGray90: 'var(--coldGray90)',
    coldGray95: 'var(--coldGray95)',
    coldGray100: 'var(--coldGray100)',
    backgroundSubtle00: 'var(--backgroundSubtle00)',
    backgroundSubtle01: 'var(--backgroundSubtle01)',
    backgroundSubtle02: 'var(--backgroundSubtle02)',
    backgroundAccent: 'var(--backgroundAccent)',
    backgroundInverse: 'var(--backgroundInverse)',
    backgroundInteractive: 'var(--backgroundInteractive)',
    backgroundDestructive: 'var(--backgroundDestructive)',
    backgroundOverlay: 'var(--backgroundOverlay)',
    borderSubtle: 'var(--borderSubtle)',
    borderAccent: 'var(--borderAccent)',
    borderInteractive: 'var(--borderInteractive)',
    borderError: 'var(--borderError)',
    borderOnColorSubtle: 'var(--borderOnColorSubtle)',
    borderOnColorAccent: 'var(--borderOnColorAccent)',
    borderWarning: 'var(--borderWarning)',
    borderSuccess: 'var(--borderSuccess)',
    textPrimary: 'var(--textPrimary)',
    textSecondary: 'var(--textSecondary)',
    textTertiary: 'var(--textTertiary)',
    textInverse: 'var(--textInverse)',
    textOnColorPrimary: 'var(--textOnColorPrimary)',
    textOnColorSecondary: 'var(--textOnColorSecondary)',
    textOnColorTertiary: 'var(--textOnColorTertiary)',
    textLink: 'var(--textLink)',
    textError: 'var(--textError)',
    textWarning: 'var(--textWarning)',
    textSuccess: 'var(--textSuccess)',
    iconPrimary: 'var(--iconPrimary)',
    iconSecondary: 'var(--iconSecondary)',
    iconTertiary: 'var(--iconTertiary)',
    iconInverse: 'var(--iconInverse)',
    iconOnColorPrimary: 'var(--iconOnColorPrimary)',
    iconOnColorSecondary: 'var(--iconOnColorSecondary)',
    iconOnColorTertiary: 'var(--iconOnColorTertiary)',
    iconLink: 'var(--iconLink)',
    iconError: 'var(--iconError)',
    iconWarning: 'var(--iconWarning)',
    iconSuccess: 'var(--iconSuccess)',
    backgroundSubtleHover: 'var(--backgroundSubtleHover)',
    backgroundAccentHover: 'var(--backgroundAccentHover)',
    backgroundInteractiveHover: 'var(--backgroundInteractiveHover)',
    backgroundDestructiveHover: 'var(--backgroundDestructiveHover)',
    borderSubtleHover: 'var(--borderSubtleHover)',
    borderAccentHover: 'var(--borderAccentHover)',
    backgroundSubtleActive: 'var(--backgroundSubtleActive)',
    backgroundAccentActive: 'var(--backgroundAccentActive)',
    backgroundInteractiveActive: 'var(--backgroundInteractiveActive)',
    backgroundDestructiveActive: 'var(--backgroundDestructiveActive)',
    borderAccentActive: 'var(--borderAccentActive)',
    borderFocus: 'var(--borderFocus)',
    borderOnColorFocus: 'var(--borderOnColorFocus)',
    backgroundInteractiveDisabled: 'var(--backgroundInteractiveDisabled)',
    backgroundDestructiveDisabled: 'var(--backgroundDestructiveDisabled)',
    borderDisabled: 'var(--borderDisabled)',
    textDisabled: 'var(--textDisabled)',
    iconDisabled: 'var(--iconDisabled)',
    backgroundMenu: 'var(--backgroundMenu)',
    backgroundOverfill: 'var(--backgroundOverfill)',
    toggle: 'var(--toggle)',
    toggleDisabled: 'var(--toggleDisabled)',
    iconsInverse: 'var(--iconsInverse)',
    conOnColorSecondary: 'var(--conOnColorSecondary)',

    notificationBackgroundSuccess: 'var(--notificationBackgroundSuccess)',
    notificationBorderSuccess: 'var(--notificationBorderSuccess)',
    notificationBackgroundInformation:
      'var(--notificationBackgroundInformation)',
    notificationBorderInformation: 'var(--notificationBorderInformation)',
    notificationBackgroundWarning: 'var(--notificationBackgroundWarning)',
    notificationBorderWarning: 'var(--notificationBorderWarning)',
    notificationBackgroundError: 'var(--notificationBackgroundError)',
    notificationBorderError: 'var(--notificationBorderError)',
  },
  spacing: {
    sp01: 'var(--sp01)',
    sp02: 'var(--sp02)',
    sp03: 'var(--sp03)',
    sp04: 'var(--sp04)',
    sp05: 'var(--sp05)',
    sp06: 'var(--sp06)',
    sp07: 'var(--sp07)',
    sp08: 'var(--sp08)',
    sp09: 'var(--sp09)',
    sp10: 'var(--sp10)',
    sp11: 'var(--sp11)',
    sp12: 'var(--sp12)',
  },
  breakpoints: {
    watch: 'var(--watch)',
    mobile: 'var(--mobile)',
    tabletPortrait: 'var(--tabletPortrait)',
    tabletLandscape: 'var(--tabletLandscape)',
    desktop: 'var(--desktop)',
    tv: 'var(--tv)',
  },
  typography: {
    tpCode02: 'var(--tpCode02)',
    tpCode01: 'var(--tpCode01)',
    tpLabel01: 'var(--tpLabel01)',
    tpHeading01: 'var(--tpHeading01)',
    tpHeading02: 'var(--tpHeading02)',
    tpHeading03: 'var(--tpHeading03)',
    tpHeading04: 'var(--tpHeading04)',
    tpHeading05: 'var(--tpHeading05)',
    tpDisplay01Light: 'var(--tpDisplay01Light)',
    tpDisplay01Bold: 'var(--tpDisplay01Bold)',
    tpDisplay02Light: 'var(--tpDisplay02Light)',
    tpDisplay02Bold: 'var(--tpDisplay02Bold)',
    tpDisplay03Light: 'var(--tpDisplay03Light)',
    tpDisplay03Bold: 'var(--tpDisplay03Bold)',
    tpDisplay04Light: 'var(--tpDisplay04Light)',
    tpDisplay04Bold: 'var(--tpDisplay04Bold)',
    tpBody02: 'var(--tpBody02)',
    tpBody01: 'var(--tpBody01)',
  },
};
